import { css } from '@linaria/core';
import { baseTheme, baseUnits } from 'styles/utils';
export const uploaderWrapper = "omponents__PresetInputsUploader__styles_ts-uploaderWrapper-ui9zmds";
export const contentWarning = "omponents__PresetInputsUploader__styles_ts-contentWarning-c13a0xgr";
export const preserUrlInstructions = "omponents__PresetInputsUploader__styles_ts-preserUrlInstructions-p1a5opze";
export const exampleUrls = "omponents__PresetInputsUploader__styles_ts-exampleUrls-eeaa7lr";
export const presetUrlTextArea = "omponents__PresetInputsUploader__styles_ts-presetUrlTextArea-p1cf5f2i";

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");